const rankings = [
  {
    rank: 1,
    title: '某顶流男星私生活全曝光：多位知情人先后发声',
    heat: '🔥 98.7万',
    tag: '娱乐圈黑料',
    trend: 'up',
  },
  {
    rank: 2,
    title: '知名互联网企业高管内部邮件流出，揭秘办公室政治',
    heat: '🔥 85.3万',
    tag: '大厂内幕',
    trend: 'up',
  },
  {
    rank: 3,
    title: '头部网红主播涉嫌虚假宣传，平台已介入调查',
    heat: '🔥 72.6万',
    tag: '网红瓜田',
    trend: 'new',
  },
  {
    rank: 4,
    title: '某综艺节目录制现场黑幕被参赛者曝光',
    heat: '🔥 64.1万',
    tag: '选秀黑幕',
    trend: 'up',
  },
  {
    rank: 5,
    title: '电竞圈重磅转会传闻：背后暗箱操作细节浮出水面',
    heat: '🔥 55.8万',
    tag: '体育争议',
    trend: 'new',
  },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[960px] mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-50 text-center mb-3">
          黑料热度榜
        </h2>
        <p className="text-sm text-foreground-400 text-center mb-10 md:mb-14">
          实时反映当前最受关注的吃瓜内容热度
        </p>
        <div className="bg-background-100 border border-background-200/60 rounded-lg overflow-hidden">
          {rankings.map((item, i) => (
            <div
              key={i}
              className={`flex items-center gap-4 p-4 md:p-5 cursor-pointer transition-colors hover:bg-background-200/50 ${
                i < rankings.length - 1 ? 'border-b border-background-200/60' : ''
              }`}
            >
              <div className={`flex-shrink-0 w-9 h-9 rounded-full flex items-center justify-center text-sm font-bold ${
                item.rank === 1
                  ? 'bg-primary-500 text-foreground-50'
                  : item.rank === 2
                  ? 'bg-accent-500/30 text-accent-400'
                  : item.rank === 3
                  ? 'bg-accent-500/20 text-accent-300'
                  : 'bg-background-200 text-foreground-500'
              }`}>
                {item.rank}
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="text-sm md:text-base font-medium text-foreground-200 truncate">
                  {item.title}
                </h3>
                <div className="flex items-center gap-3 mt-1.5">
                  <span className="text-xs text-primary-400 bg-primary-500/10 px-2 py-0.5 rounded-full whitespace-nowrap">
                    {item.tag}
                  </span>
                  {item.trend === 'new' && (
                    <span className="text-xs text-accent-400 whitespace-nowrap">🆕 新上榜</span>
                  )}
                  {item.trend === 'up' && (
                    <span className="text-xs text-primary-400 whitespace-nowrap">📈 热度上升</span>
                  )}
                </div>
              </div>
              <div className="flex-shrink-0 text-right">
                <p className="text-sm font-semibold text-accent-400 whitespace-nowrap">{item.heat}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}